
import { Options, Vue } from 'vue-class-component'
import { mapState, mapMutations } from 'vuex'
import 'animate.css'
import COVERAPP from '@/utils/COVERAPP'

let notice = '答题结束，对你的成绩满意吗？欢迎再次挑战哦！';
let imageData = '';
@Options({
  data() {
    return {
      notice: notice,
      score: 0,
      isShareImage: false,
    }
  },
  computed: {
    ...mapState(['userInfo', 'shareData', 'activityData'])
  },
  created() {
    this.score = this.$route.query.score;
  },
  mounted() {
    const _this = this;
    this.$common.pageLoaded()
    let homeShareData = JSON.parse(JSON.stringify(this.shareData))
    homeShareData.link = window.location.href
    this.$common.onshare(homeShareData)
    this.$common.track('load', '进入首页')
    this.noticePlay()

    this.$common.getUser((res) => {
      const userinfo = JSON.parse(JSON.stringify(res));
      if (!userinfo || !userinfo.token) {
        return;
      }

      _this.SET_USERINFO(userinfo);
      _this.generatePoster();
    });
  },
  methods: {
    ...mapMutations(['SET_USERINFO', 'SET_SHAREDATA', 'SET_DIALOGDATA' , 'SET_ACTIVITYDATA']),
    noticePlay() {
      this.playAudio();
      let index = 0;
      let timer = setInterval(() => {
        this.notice = notice.substr(0, index)
        if (index >= notice.length) {
          clearInterval(timer)
        }
        index++;
      }, 100)
    },
    playAudio() {
      const audio = new Audio('https://yunyingcdn.thecover.cn/o_1ht3aqvdf1ns41uqjetglsm1fil9.wav');
      audio.play();
    },
    generatePoster() {
      const _this = this;
      let nickname = this.userInfo.nickname;
      if (COVERAPP.Attribute.isApp() && COVERAPP.Attribute.isIOS()) {
        try {
          nickname = decodeURIComponent(escape(window.atob(nickname)))
        }
        catch(e) {
          nickname = this.userInfo.nickname;
        }
      }
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.src = this.activityData.templateConfig.sharePosterBg;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx: any = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        ctx.font = "bold 120px 黑体";
        ctx.textAlign="center";
        ctx.fillStyle=this.activityData.templateConfig.shareTextColor || "#A05050";
        ctx.fillText(this.score || 0, 640, 1280);
        ctx.font = "bold 48px 黑体";
        ctx.textAlign="center";
        ctx.fillStyle=this.activityData.templateConfig.shareTextColor || "#050708";
        ctx.fillText((nickname || '封面网友'), 540, 1110);
        imageData = canvas.toDataURL();
        _this.isShareImage = true;
      };
    },
    handleShare() {
      const _this = this;
      _this.$common.track('click', '分享海报')
      if (COVERAPP.Attribute.isApp() && imageData) {
        const image = imageData.split(';base64,')[1];
        COVERAPP.Method.shareImage({
          image,
          title: this.activityData.title,
          desc: this.activityData.title,
          imgUrl: this.activityData.share.image,
          link: this.activityData.share.link,
          callback() {
            _this.$common.track('share', '分享海报')
          },
        });
      }
    },
  },
})
export default class End extends Vue {}
